import type { TCRMIntegration } from "@/shared/types";

export const INTEGRATIONS: TCRMIntegration[] = [
  {
    id: "hubspot",
    title: "Hubspot",
    type: "CRM",
    internalName: "hubspot",
    logo: "https://assets.storydoc.com/assets/images/integrations/hubspot.jpg",
    connected: null,
    customIntegration: false,
    available: true,
    mappingFields: [
      "Person.company",
      "Person.email",
      "Person.firstname",
      "Person.lastname",
      "Person.phone",
      "Person.website",
      "Company.city",
      "Company.domain",
      "Company.industry",
      "Company.name",
      "Company.phone",
      "Company.state",
    ],
    variables: [],
    plan: "team",
  },
  {
    id: "gong",
    title: "Gong",
    type: "Sales Enablement",
    internalName: "gong",
    available: true,
    logo: "https://assets.storydoc.com/assets/images/integrations/gong.jpg",
    connected: null,
    customIntegration: false,
    variables: [],
    plan: "team",
  },
  {
    id: "salesforce",
    title: "Salesforce",
    type: "CRM",
    hasSandbox: true,
    internalName: "salesforce",
    logo: "https://assets.storydoc.com/assets/images/integrations/salesforce.jpg",
    connected: null,
    customIntegration: false,
    available: true,
    mappingReference:
      "https://developer.salesforce.com/docs/atlas.en-us.object_reference.meta/object_reference/sforce_api_objects_contact.htm",
    mappingFields: [
      "AccountId",
      "AssistantName",
      "AssistantPhone",
      "Birthdate",
      "CanAllowPortalSelfReg",
      "CleanStatus",
      "ConnectionReceivedId",
      "ConnectionSentId",
      "Department",
      "Description",
      "DoNotCall",
      "Email",
      "EmailBouncedDate",
      "EmailBouncedReason",
      "Fax",
      "FirstCallDateTime",
      "FirstEmailDateTime",
      "FirstName",
      "HasOptedOutOfEmail",
      "HasOptedOutOfFax",
      "HomePhone",
      "IndividualId",
      "IsDeleted",
      "IsEmailBounced",
      "IsPersonAccount",
      "LastActivityDate",
      "LastName",
      "LastReferencedDate",
      "LastViewedDate",
      "LeadSource",
      "MailingAddress",
      "MailingCity",
      "MailingState",
      "MailingCountry",
      "MailingPostalCode",
      "MailingStateCode",
      "MailingCountryCode",
      "MailingStreet",
      "MailingGeocodeAccuracy",
      "MailingLatitude",
      "MailingLongitude",
      "MasterRecordId",
      "MiddleName",
      "MobilePhone",
      "Name",
      "OtherAddress",
      "OtherCity",
      "OtherCountry",
      "OtherPostalCode",
      "OtherState",
      "OtherCountryCode",
      "OtherStateCode",
      "OtherGeocodeAccuracy",
      "OtherLatitude",
      "OtherLongitude",
      "OtherPhone",
      "OtherStreet",
      "OwnerId",
      "Phone",
      "RecordTypeId",
      "ReportsToId",
      "Salutation",
      "Suffix",
      "Title",
      "Account.Name",
      "Account.NumberOfEmployees",
      "Account.AnnualRevenue",
      "Account.Industry",
      "Account.Phone",
      "Account.Type",
      "Account.Website",
    ],
    variables: [
      {
        type: "input",
        name: "salesforceId",
        title: "Salesforce Id",
        mapping: "Id",
        hidden: "true",
        tip: "Your prospect id, as set in your Salesforce CRM.",
        validation: {
          required: false,
        },
      },
    ],
    plan: "team",
  },
  {
    id: "pipedrive",
    title: "Pipedrive",
    type: "Sales Enablement",
    internalName: "pipedrive",
    logo: "https://assets.storydoc.com/assets/images/integrations/pipedrive.jpg",
    connected: null,
    customIntegration: false,
    available: false,
    variables: [
      {
        type: "input",
        name: "prospectEmail",
        title: "Prospect email",
        default: "",
        tip: "Your prospect email, as set in your CRM.",
        validation: {
          required: false,
        },
      },
    ],
    plan: "team",
  },
  {
    id: "salesloft",
    title: "Salesloft",
    type: "CRM",
    internalName: "salesloft",
    logo: "https://assets.storydoc.com/assets/images/integrations/salesloft.jpg",
    connected: null,
    customIntegration: false,
    available: true,
    variables: [
      {
        type: "input",
        name: "salesloftId",
        title: "Salesloft Id",
        mapping: "Person.id",
        hidden: "true",
        tip: "Your prospect id, as set in your Salesloft CRM.",
        validation: {
          required: false,
        },
      },
    ],
    plan: "team",
  },
  {
    id: "outreach",
    title: "Outreach.io",
    type: "Sales Enablement",
    internalName: "outreach",
    logo: "https://assets.storydoc.com/assets/images/integrations/outreach.jpg",
    connected: null,
    customIntegration: false,
    available: false,
    variables: [
      {
        type: "input",
        name: "prospectEmail",
        title: "Prospect email",
        default: "",
        tip: "Your prospect email, as set in your CRM.",
        validation: {
          required: false,
        },
      },
    ],
    plan: "team",
  },
  {
    id: "zoho",
    title: "Zoho",
    type: "CRM",
    internalName: "zoho",
    logo: "https://assets.storydoc.com/assets/images/integrations/zoho.jpg",
    connected: null,
    customIntegration: false,
    available: false,
    variables: [
      {
        type: "input",
        name: "prospectEmail",
        title: "Prospect email",
        default: "",
        tip: "Your prospect email, as set in your CRM.",
        validation: {
          required: false,
        },
      },
    ],
    plan: "team",
  },
];
